export type CancelTourDate = {
  type: 'CANCEL_TOUR_DATE';
  id: string;
};

export const cancelTourDate = (id: string): CancelTourDate => ({
  type: 'CANCEL_TOUR_DATE',
  id,
});
